export default __webpack_public_path__ + "static/peachtree-pirchforks-2637efe2b5ff6891d0b631b8d862b84f.jpg";